// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-exclusions .chevron-down {\n    color: #a4a0a0;\n}\n\n.container-exclusions .date {\n    font-weight: normal;\n    float: left;\n    margin-top: 5px;\n}", ""]);
// Exports
module.exports = exports;
